import { schema } from '../../utils/schema';

export const LowecaseError = schema({
  code: 'string',
  message: 'string',
  description: 'string',
});

export const UppercaseError = schema({
  Code: 'string',
  Message: 'string',
  Description: 'string',
});

export const InnerError = schema({
  error: {
    code: 'string',
    message: 'string',
  },
});

type LowercaseError = typeof LowecaseError.infer;
type UppercaseErrorA = typeof UppercaseError.infer;
type InnerErrorA = typeof InnerError.infer;

export type AtsError = LowercaseError | UppercaseErrorA | InnerErrorA;
